import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import Product from "../components/Product";
import PPEForm from "../components/PPEForm";
import Specifications from "../components/Specifications";

// Import data from helpers
import { surfaceWipesProducts } from "../helpers/surface-wipes/products";
import { surfaceWipesFormFields } from "../helpers/surface-wipes/formConfig";
import { surfaceWipesSpecifications } from "../helpers/surface-wipes/specifications";

const SurfaceWipes: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "Surface Wipes Quote",
      path: "/surface-wipes.html",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Page Title and Products - Unified Container */}
        <div className="w-full py-8 bg-white">
          <div className="page-container">
            <h1 className="page-title">
              Disinfectant Wipes in Bulk
            </h1>
            <p className="page-description">
              Our disinfectant wipes are easy-to-use and very effective against
              germs! We offer household and hospital-grade sterilization in soft
              packs or canisters. With EPA registered wipes and brands you trust
              -- you will feel confident, clean and safe! Simply request a quote
              below and we'll send our best option and pricing for surface
              wipes.
            </p>
            
            {/* Product Grid */}
            <div className="mt-8">
              <Product products={surfaceWipesProducts} aspectRatio="surface" />
            </div>
          </div>
        </div>

        {/* Get Started Form */}
        <PPEForm
          title="Get Started"
          description="Get in touch today or call"
          phoneNumber="877-927-3691"
          fields={surfaceWipesFormFields}
          formName="Surface Wipes PPE.us"
        />

        {/* Surface Wipes Specifications */}
        <Specifications
          title="Surface Wipes Specifications"
          items={surfaceWipesSpecifications}
        />
      </main>
    </div>
  );
};

export default SurfaceWipes;
